import React from 'react';
import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from 'react-router-dom';

type ExternalAnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;
type InternalLinkProps = Omit<RouterLinkProps, 'to'> & {
  href: RouterLinkProps['to'];
};

type AppLinkProps = InternalLinkProps &
  ExternalAnchorProps & {
    prefetch?: boolean;
  };

const isExternalHref = (href: RouterLinkProps['to']) =>
  typeof href === 'string' &&
  /^(https?:\/\/|mailto:|tel:|#)/.test(href);

const Link = React.forwardRef<HTMLAnchorElement, AppLinkProps>(
  ({ href, children, reloadDocument, prefetch: _prefetch, ...rest }, ref) => {
    if (isExternalHref(href)) {
      return (
        <a ref={ref} href={String(href)} {...rest}>
          {children}
        </a>
      );
    }

    return (
      <RouterLink
        ref={ref}
        to={href}
        reloadDocument={reloadDocument}
        {...rest}
      >
        {children}
      </RouterLink>
    );
  },
);

Link.displayName = 'Link';

export default Link;
